import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent, ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { ItemToSynchronizeInfo } from '../../context/SynchronizationStatusContext';
import { IconDeprecated, IconType } from '../../misc/IconDeprecated/IconDeprecated';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import styles from './ItemsToSynchronizeListItem.module.css';
export type ItemsToSynchronizeListItemProps = ComponentProps<'div'> & {
  itemToSynchronizeInfo: ItemToSynchronizeInfo;
};
export const ItemsToSynchronizeListItem: FunctionComponent<ItemsToSynchronizeListItemProps> = React.memo(props => {
  const $ = _c(21);
  const {
    itemToSynchronizeInfo,
    className,
    ...remainingProps
  } = prepareProps({
    props,
    ignoreChildren: true
  });
  const {
    t
  } = useTranslation("record-it-components");
  const t0 = classes(className, styles.listItem);
  let t1;
  if ($[0] !== itemToSynchronizeInfo.failed) {
    t1 = !itemToSynchronizeInfo.failed ? undefined : <IconDeprecated name="times" type={IconType.Light} className={styles.failedIcon} data-testid="ItemsToSynchronizeListItem.failedIcon" />;
    $[0] = itemToSynchronizeInfo.failed;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== itemToSynchronizeInfo.entityName) {
    t2 = <span className={styles.entityName}>{itemToSynchronizeInfo.entityName}</span>;
    $[2] = itemToSynchronizeInfo.entityName;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className={styles.header}>{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("synchronization.ItemsToSynchronizeListItem.idLabel");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <span>{t4}</span>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== itemToSynchronizeInfo.id) {
    t6 = <span className={styles.id}>{itemToSynchronizeInfo.id}</span>;
    $[11] = itemToSynchronizeInfo.id;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5 || $[14] !== t6) {
    t7 = <div>{t5}{t6}</div>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== remainingProps || $[17] !== t0 || $[18] !== t3 || $[19] !== t7) {
    t8 = <div {...remainingProps} className={t0}>{t3}{t7}</div>;
    $[16] = remainingProps;
    $[17] = t0;
    $[18] = t3;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
});